import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/groups';

export async function query(values: Record<string, any>): Promise<{ groups: Record<string, any>[]; totalMatches: number }> {
	const url: URL = new URL(rootUrl);

	url.searchParams.append('offset', String(0));
	url.searchParams.append('amount', String(values.amount));

	if (values.date !== null) {
		const [dateFrom, dateUntil] = values.date;
		if (dateFrom !== null) url.searchParams.append('dateFrom', dateFrom.format('YYYY-MM-DD'));
		if (dateUntil !== null) url.searchParams.append('dateUntil', dateUntil.format('YYYY-MM-DD'));
	}

	if (values.status !== 'all') url.searchParams.append('status', values.status);
	if (values.groupId !== undefined) url.searchParams.append('groupId', values.groupId);
	if (values.filter.target !== 'all') url.searchParams.append('filter', values.filter.target);
	if (values.filter.search !== '') url.searchParams.append('filterSearch', `%${values.filter.search}%`);

	const response: Response = await BBApi.get(url.href);
	const { groups, totalMatches }: { groups: Record<string, any>[]; totalMatches: number } = await response.json();
	return { groups, totalMatches };
}

export async function get(id: number): Promise<any> {
	const response: Response = await BBApi.get(rootUrl + `/${id}`);
	const json: any = await response.json();
	return json;
}

export async function create(group: Record<string, any>): Promise<number> {
	group.image = group?.image?.split(';base64,').pop();
	const response: Response = await BBApi.post(rootUrl, group);

	if (response.ok === false) {
		throw new Error("Can't create group");
	}

	const { groupId }: Record<string, any> = await response.json();
	return groupId;
}

export async function validate(name: string): Promise<void> {
	const response: Response = await BBApi.post(rootUrl + `/validate`, { name });

	if (response.ok === false) {
		throw new Error('Group name occupied');
	}
}

export async function update(id: number, group: Record<string, any>): Promise<void> {
	if (group.password === '') group.password = null;
	if (group.responsible === undefined) group.responsible = null;

	if (group.image !== null) {
		group.image = group?.image?.split(';base64,').pop();
	}

	const response: Response = await BBApi.put(rootUrl + `/${id}`, group);

	if (response.ok === false) {
		throw new Error('Group not updated');
	}
}

export async function remove(id: number): Promise<void> {
	const response: Response = await BBApi.del(rootUrl + `/${id}`);

	if (response.ok === false) {
		throw new Error('Group not deleted');
	}
}

export async function getMembers(id: number): Promise<Record<string, any>[]> {
	const response: Response = await BBApi.get(rootUrl + `/${id}/members`);

	if (response.ok === false) {
		throw new Error("Can't get members");
	}

	const json: Record<string, any>[] = await response.json();
	return json;
}

export async function updateMemberRank(groupId: number, userId: number, rank: number): Promise<void> {
	const response: Response = await BBApi.put(rootUrl + `/${groupId}/members/${userId}`, { rank });

	if (response.ok === false) {
		throw new Error('Group member not updated');
	}
}

export async function removeMember(groupId: number, userId: number): Promise<void> {
	const response: Response = await BBApi.del(rootUrl + `/${groupId}/members/${userId}`);

	if (response.ok === false) {
		throw new Error('Group member not removed');
	}
}

export async function addMember(groupId: number, userId: number, rank: number): Promise<void> {
	const response: Response = await BBApi.post(rootUrl + `/${groupId}/members`, { userId, rank });

	if (response.ok === false) {
		throw new Error('Group member not added');
	}
}

export async function getMessages(id: number): Promise<Record<string, any>[]> {
	const response: Response = await BBApi.get(rootUrl + `/${id}/messages`);

	if (response.ok === false) {
		throw new Error("Can't get messages");
	}

	const json: Record<string, any>[] = await response.json();
	return json;
}

export async function updateMessage(groupId: number, messageId: number, status: number): Promise<void> {
	const response: Response = await BBApi.put(rootUrl + `/${groupId}/messages/${messageId}`, { status });

	if (response.ok === false) {
		throw new Error("Can't get messages");
	}
}
